import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-sidebar-header',
    templateUrl: './sidebar-header.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarHeaderComponent implements OnInit {
    @HostBinding() class = 'eui-app-sidebar-header';

    constructor(
        private asService: UxAppShellService,
    ) {}

    ngOnInit() {
        this.asService.activateSidebarHeader();
    }
}
